interface Dependencies {
	[type : string] : string
}

export interface ConfigOptions {
	dependencies : Dependencies;
	debug : boolean;
	[name : string] : any;
}

/**
 * Contains the application base config.
 * The base config can be extended or overwritten either via
 * new Application ($ctx, config) during bootstrapping the application or via
 * overriding the Tc.Config object in your project.
 *
 * @author Remo Brunschwiler
 * @namespace Tc
 * @class Config
 * @static
 */
export let config : ConfigOptions = {
	/**
	 * The paths for the different types of dependencies.
	 *
	 * @property dependencies
	 * @type Object
	 */
	dependencies: {
			css: '/css/dependencies',
			js: '/js/dependencies',
	},

	debug: false,
};



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/terrific/config.ts